<template>
  <base-dialog
    v-if="hasPaymentFailed"
    title="Online Payment Failed"
    @close="ClickDialogClose"
  >
    <template #default>
      <p>{{ paymentErrorMsg }}</p>
    </template>
    <template #actions>
      <base-button @click="ClickDialogClose">OK</base-button>
    </template>
  </base-dialog>

  <base-dialog
    v-if="paymentProcessing"
    title="Payment is being processed..."
    @waiting="ClickWaitingDialog"
  >
    <template #default>
      <div class="d-flex justify-content-center align-items-center">
        <img
        class="logo"
        src="@/assets/loader.gif"
        width="100"
      />
      <p class="m-0">{{ waitingMessage }}</p>
      </div>
    </template>
  </base-dialog>
  <transition name="fade" mode="out-in">
    <base-card>
      <h3>Online Payment :</h3>

      <form @submit.prevent="initGateway">
        <div class="">
          <label for="namelbl">Name on the card:</label>
          <input
            id="name"
            name="name"
            type="text"
            ref="nameoncardInput"
            v-model="cardName"
            :disabled="isConfirmed"
            required
          />
        </div>
        <div class="">
          <label for="cardnumberlbl">Card Number:</label>
          <input
            id="cardnumber"
            name="cardnumber"
            type="text"
            ref="cardnumberInput"
            pattern="[0-9]{4} [0-9]{4} [0-9]{4} [0-9]{4}"
            :value="cardNumber"
            @input="makeCardNumber"
            :disabled="isConfirmed"
            required
          />
        </div>
        <div class="">
          <label for="expirelbl">Expire date (mm/yy):</label>
          <input
            id="expire"
            name="expire"
            type="text"
            ref="expireInput"
            pattern="[0-9]{2}/[0-9]{2}"
            :value="cardMMYY"
            :disabled="isConfirmed"
            @input="makeExpireDate"
            required
          />

          <label for="cvvlbl">CVV:</label>
          <input
            id="cvv"
            name="cvv"
            type="text"
            ref="cvvInput"
            pattern="[0-9]{3}"
            :value="cardCVV"
            :disabled="isConfirmed"
            @input="makeCVV"
            required
          />
        </div>
        <br />

        <div>
          <base-button v-if="subData" type="submit">Confirm Payment</base-button>
        </div>
      </form>
    </base-card>
  </transition>
</template>

<script>
//import { BreedingRhombusSpinner } from 'epic-spinners';
//import Loading from 'vue-loading-overlay';
import { PaymentRD } from '../../../../config';

export default {
  props: ['intendToPayBookingDetails', 'solution'],
  inject: ['getBookingConfirmStatus'],
  //components: { Loading },
  // emits: ['payment-approved'],

  data() {
    return {
      whileWaitings: [
        'Please DO NOT close the window and wait while the payment is being processed...',
        'Please DO NOT close the window and wait for your booking confirmation...',
      ],
      subData: true,
      waitingPause: 15,
      allowClick: true,
      waitingAnimateSpeed: 2000,
      waitingAnimiateSize: 60,
      waitingClickCount: 0,
      visibility: true,
      isConfirmed: false,
      testmode: true,
      billerCode: null,
      tokenUrl: null,

      bookingConfirmedDetails: null,

      // card related information
      waitingMessage: 'Please do not reload page, press back or home button.',
      paymentErrorMsg:
        'Your payment attends failed, please contact your bank for more details',

      hasPaymentFailed: false,
      paymentAmountCents: 0,
      paymentSurchargeCents: 0,
      paymentTotalCents: 0,
      paymentAuthKeys: [],

      cardMMYY: '', // single field with "/"

      cardName: '',
      cardNumber: '',
      cardMonth: '',
      cardYear: '',
      cardCVV: '',

      finalCardNumberForTx: '',

      paymentProcessing: false,
      failCount: 0,
      keyParameters: {
        RedirectionUrl: PaymentRD,
        ProcessTxnData: {
          Action: 'payment',
          Amount: this.checkPricingInNumber(
            this.intendToPayBookingDetails.priceIncludeSurcharge
          ),
          AmountOriginal: this.checkPricingInNumber(
            this.intendToPayBookingDetails.price
          ),
          AmountSurcharge: this.checkPricingInNumber(
            this.intendToPayBookingDetails.surcharge
          ),
          Currency: 'AUD',
          MerchantReference: 'FCCBooking',
          Crn1: this.solution.rtype,
          Crn2: this.solution.account,
          Crn3:
            this.solution.selectedVenue.VenueId +
            '-' +
            this.solution.user.lastName,
          BillerCode: this.solution.env.billercode,
          TokenisationMode: 3,
          TestMode: this.solution.env.testmode,
          SubType: 'single',
          Type: 'internet',
          FraudScreeningRequest: {
            PerformFraudScreening: false,
            TxnSourceWebsiteURL: 'app.fairfieldcity.nsw.gov.au',
          },
        },
      },
    };
  },

  watch: {
    cardNumber() {
      if (this.cardNumber.length >= 19) {
        this.finalCardNumberForTx = this.cardNumber.replace(/\s+/g, '');
      }
    },

    billerCode() {
      //   console.log('solution, env', this.solution, this.env);
      if (this.solution.env !== null) {
        //        console.log(' env 2', this.solution.env, this.billerCode);
        this.tokenUrl = this.solution.env.tokenUrl;
      }
    },

    paymentAuthKeys() {
      // if this updated, then call submit payment
      //  console.log('auth key', this.paymentAuthKeys);
      this.submitPayment(this.paymentAuthKeys);
    },
  },

  methods: {
    getTokenUrl() {
      return this.tokenUrl;
    },

    checkPricingInNumber(price) {
      let number = parseFloat(price) * 100;
      //    console.log('here is the convertion ', price, number);
      return Math.round(number);
    },

    ClickWaitingDialog() {
      //    console.log('this waiting dailog');

      if (this.allowClick) {
        this.showWaitingMessage();

        this.ticker = setInterval(this.setClickAllow, 5000);
      }
    },

    setClickAllow() {
      this.allowClick = true;
    },

    showWaitingMessage() {
      this.allowClick = false;
      if (this.waitingClickCount >= 3) {
        this.visibility = true;
        this.waitingAnimateSpeed = 2500;
        this.waitingAnimiateSize = 60;
        this.waitingClickCount = 0;
        this.paymentProcessing = false;
      } else {
        this.waitingClickCount += 1;
        const msgLengths = this.whileWaitings.length;
        const index = Math.floor(Math.random() * msgLengths);

        this.waitingMessage = this.whileWaitings[index];
        this.waitingAnimateSpeed = this.waitingAnimateSpeed - 400;
        //this.waitingAnimiateSize = this.waitingAnimiateSize + 5;
      }
    },

    ClickDialogClose() {
      this.hasPaymentFailed = false;
      if (this.failCount < 3) {
        // this.initGateway();
        console.log('Testing the payment invalid data popup...');
      } else {
        this.paymentErrorMsg = `Your payment attend(s) exceeds the limit, contact your card issuer`;
        this.hasPaymentFailed = true;
        this.paymentProcessing = false;
      }
    },

    makeCVV($event) {
      this.cardCVV = $event.target.value.trim();

      this.cardCVV = this.cardCVV.slice(0, 3);
    },

    makeExpireDate($event) {
      this.cardMMYY = $event.target.value.trim();

      if (
        this.cardMMYY.length === 2 &&
        $event.inputType !== 'deleteContentBackward'
      ) {
        this.cardMMYY = this.cardMMYY + '/';
      }
      this.cardMMYY = this.cardMMYY.slice(0, 5);
      const cardMY = this.cardMMYY.split('/');
      this.cardMonth = cardMY[0];
      this.cardYear = cardMY[1];
    },

    makeCardNumber($event) {
      this.cardNumber = $event.target.value;

      if (
        (this.cardNumber.length === 4 ||
          this.cardNumber.length === 9 ||
          this.cardNumber.length === 14) &&
        $event.inputType !== 'deleteContentBackward'
      ) {
        this.cardNumber = this.cardNumber + ' ';
      }
      if (this.cardNumber.length > 19)
        this.cardNumber = this.cardNumber.slice(0, 19);
    },

    makeCurrencyString(amount) {
      let amountString = amount.toString().padStart(3, '0');
      let len = amountString.length;
      return (
        '$' +
        amountString.substring(0, len - 2) +
        '.' +
        amountString.substring(len - 2)
      );
    },

    // getting the authkey
    initGateway() {
      this.startGateway(this.keyParameters, this.tokenUrl).then((result) => {
        this.paymentProcessing = true;
        this.subData = true;
        if (
          result['APIResponse']['ResponseCode'] === 0 &&
          result['APIResponse']['ResponseText'] === 'Success' &&
          result['AuthKey'] !== undefined
        ) {
          this.paymentAuthKeys = result['AuthKey'];
        } else {
          this.hasPaymentFailed = true;
          this.paymentErrorMsg =
            "Oops, there's a problem with the booking, please try to restart the booking process";
          return;
        }
      });
    },
    startGateway: async (keyParameters, tokenUrl) => {
      if (keyParameters !== null) {
        let authKeyResult = await fetch(
          tokenUrl + `/api/financial/auth/otakey`,
          {
            method: 'POST',
            cache: 'no-cache',
            body: JSON.stringify(keyParameters),
          }
        );
        return await authKeyResult.json();
      }
    },

    // on submit payment with authkey
    submitPayment(authKey) {
      //  console.log('auth key', this.paymentAuthKeys, authKey);
      // eslint-disable-next-line no-undef
      globalThis.CBA.ProcessPayment({
        AuthKey: authKey,
        CardHolderName: this.cardName.trim(),
        CardNumber: this.finalCardNumberForTx, //'5123456789012346', //this.cardNumber,
        Cvn: this.cardCVV.trim(), //'123', //this.cardCVV,
        ExpiryMonth: this.cardMonth, //'99', //this.cardMonth,
        ExpiryYear: this.cardYear, //'00', //this.cardYear,
        CallbackFunction: this.paymentCallback.bind(null, this),
        Type: 'CREDITCARD',
      });
    },

    // after the payment processed
    paymentCallback: async (parent, result) => {
      if (result['AjaxResponseType'] !== 0 || result['ApiResponseCode']) {
        parent.paymentErrorMsg =
          "Oops, there's a problem with the payment, please try again ";
        parent.hasPaymentFailed = true;
        parent.paymentProcessing = false;
        return;
      }

      fetch(
        parent.tokenUrl + `/api/financial/auth/result/${result['ResultKey']}`
      )
        .then((response) => {
          return response.json();
        })
        .then((fullResult) => {
          // console.log('full result', fullResult);          
          parent.subData = false;
          parent.isConfirmed = true;
          if (
            fullResult['TxnResp']['ResponseText'] === 'Approved' &&
            fullResult['TxnResp']['BankResponseCode'] == '00'
          ) {
            //   parent.$emit('payment-approved', [fullResult]);
            parent.$eventBus.emit('paymentApproved', [fullResult]);
            parent.paymentProcessing = false;
            parent.hasPaymentFailed = false;
            return;
          } else {
            parent.hasPaymentFailed = true;
            parent.failCount += 1;
            parent.paymentErrorMsg = `Your payment of $${(
              fullResult['TxnResp']['Amount'] / 100
            ).toFixed(2)} failed with reason: ${
              fullResult['TxnResp']['ResponseText']
            }`;
          }
          parent.paymentProcessing = false;
        });
    },
  },

  mounted() {
    this.billerCode = this.solution.env.billercode;
    this.testmode = this.solution.env.testmode;
  },

  created() {
    this.bookingConfirmedDetails = this.getBookingConfirmStatus();
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Courier+Prime:wght@400;700&display=swap');

p.paymentWait {
  right: -50px;
  position: relative;
  word-wrap: break-word;
}

label {
  font-kerning: inherit;
  display: block;
  margin-top: 0.75rem;
}

input {
  font-weight: bold;
  display: block;
  width: 100%;
  font: inherit;
  padding: 0.25rem;
  border: 1px solid #ccc;
  /* font-family: 'Courier Prime', monospace; */
  font-size: 25px;
}

input:focus {
  outline: none;
  border-color: #7b05e9;
  background-color: #ececec;
}

.fade-enter-active {
  transition: opacity 0.5s ease-in-out;
}

.fade-enter-from {
  opacity: 0;
}
</style>
